<template>
  <ModalView ref = "settings_modal_view_ref"
             :open_level = "1"
             type_modal = "internal"
             position = "fixed"
             :caption = "this.loc('Смена пароля')"
             @click_close = "this.$emit('closeChangePasswordModal')">
    <div class = "changePasswordModal__container">

      <div class = "changePasswordModal__container__group">
        <LabelComponent class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        label_text = "Старый пароль"/>
        <InputField class = "changePasswordModal__container__input"
                    type = "password"
                    label_text = "Старый пароль"/>
      </div>
      <div class = "changePasswordModal__container__group">
        <LabelComponent class = "changePasswordModal__container__header"
                        label_type = "button/large/medium 14"
                        label_text = "Новый пароль"/>
        <InputField class = "changePasswordModal__container__input"
                    type = "password"
                    label_text = "Новый пароль"/>
      </div>
      <ButtonComponent class = "changePasswordModal__container__button"
                       label = "Изменить"
                       elementType = "default-bg"/>
    </div>
  </ModalView>
</template>

<script>
import builder from '../../../assets/v1/js/builder';
import ModalView from '../../ModalView';
import LabelComponent from '../../unit/Label';
import ButtonComponent from '../../unit/Button';
import InputField from '../../unit/InputField';

export default builder({
  name: 'ChangePasswordModal',
  emits: ['closeChangePasswordModal'],
  components: {
    ModalView,
    LabelComponent,
    ButtonComponent,
    InputField,
  },
});
</script>

<style lang = "less">
@import url('../../../assets/v1/less/constants.less');

.changePasswordModal {
  &__container {
    min-width: 250px;
    width: 15vw;
    display: grid;
    grid-row-gap: 20px;

    &__group {
      display: grid;
      grid-row-gap: 10px;
    }
    &__input {
      width: 100%;
    }
  }

}
</style>
